import { Promesse } from '@components/promesse/models';
import { Block } from '@shared/models';

export const promesseMock: Block<Promesse> = {
  type: 'promesse',
  data: {
    title: {
      text: `[[Chez nous y’a que les oignons qui font pleurer.]]\\\\Craquez pour nos cuisines Made in France, astucieuses et pas chères`,
      as: 'span',
    },
    pictos: [
      {
        svg: '/assets/tmp/store.svg',
      },
      {
        svg: '/assets/tmp/store.svg',
      },
      {
        svg: '/assets/tmp/store.svg',
      },
    ],
  },
};
